import React, { useState, useEffect, useRef } from "react";
import Request from "../../core/httpClient";
import cogoToast from "cogo-toast";

import { Helmet } from "react-helmet";
import Sidebar from "../header/sidebar";
import Header from "../header/header";


const request = new Request();
const CategoriesCrud = () => {
  const [categories, setCategories] = useState([]);
  const [nombre, setNombre] = useState("");
  const [idFraccionamiento, setIdFraccionamiento] = useState(localStorage.getItem("frac") || 0);
  const [editId, setEditId] = useState(null);



  const inputRef = useRef(null);
  // Leer categorías
  const getCategories = async () => {
    const data = { id: idFraccionamiento };
    const response = await request.post("/commonArea/get/categories", data);
    if (!response.error && response.categories) {
      setCategories(response.categories);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  // Crear o actualizar
  const handleSave = async (e) => {
    e.preventDefault();
    const data = { nombre, id_fraccionamiento: idFraccionamiento };

    let response;
    if (editId) {
      response = await request.put(`/commonArea/update/category/${editId}`, data);
      if (response.updated) {
        cogoToast.success("Categoría actualizada");
      }
    } else {
      response = await request.post("/commonArea/create/category", data);
      if (response.created) {
        cogoToast.success("Categoría creada");
      }
    }

    setNombre("");
    setEditId(null);
    getCategories();
  };

  // Editar
  const handleEdit = (cat) => {
    setNombre(cat.nombre);
    setIdFraccionamiento(cat.id_fraccionamiento);
    setEditId(cat.id_categoria);
  };

  // Eliminar
  const handleDelete = async (id) => {
    const response = await request.delete(`/commonArea/delete/category/${id}`);
    if (response.deleted) {
      cogoToast.success("Categoría eliminada");
      getCategories();
    }
  };

  return (
    <div className="admin column">
      <Helmet>
        <title>{process.env.REACT_APP_NAME} - Categorías</title>
      </Helmet>
      <Header
        // reload={reload}
        // change={changeFrac}
        sidebar={true}
        active="activas"
        parent="areas"
        panel="panel3"
        nav="operacion"
      // menu={menu}
      />

      {/* Contenedor flex para sidebar + contenido */}
      <div style={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
        <div id="sidebar" style={{ width: "220px", borderRight: "1px solid #ddd" }}>
          <Sidebar />
        </div>

        <main style={{ flex: 1, padding: "20px" }}>
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <form onSubmit={handleSave} style={{ marginBottom: "20px" }}>
              <input
                type="text"
                placeholder="Nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
                required
                className="input input-modals"
              />
              <button type="submit" style={{ padding: "8px 14px", color: "white" }} className="btn btn-primary btn-small" >
                {editId ? "Actualizar" : "Crear"}
              </button>
            </form>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Nombre</th>
     
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((cat) => (
                  <tr key={cat.id_categoria}>
                    
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>{cat.nombre}</td>
                   
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      <button
                        onClick={() => handleEdit(cat)}
                        style={{ display: "inline-block", marginRight: "8px", padding: "8px 14px", color: "white" }}
                        className="btn btn-primary btn-small"
                      >
                        Editar <i className="fas fa-edit"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(cat.id_categoria)}
                        style={{ display: "inline-block", padding: "8px 14px", color: "white" }}
                        className="btn btn-secondary btn-small"
                      >
                        Eliminar <i className="fas fa-trash-alt"></i>
                      </button>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );


};

export default CategoriesCrud;
